import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../../utils/apiConfig';
import UserActivityTimeline from './UserActivityTimeline';

const UsersActivityTab = ({ token, dateRange }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_ENDPOINTS.BASE_URL}/api/analytics/dashboard/users?startDate=${dateRange.start}&endDate=${dateRange.end}`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        const result = await response.json();

        if (result.success && result.data.available) {
          setUsers(result.data.users);
        }
      } catch (err) {
        console.error('Erreur chargement users:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token, dateRange]);

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Chargement...</div>;
  }

  // Si un utilisateur est sélectionné, afficher sa timeline
  if (selectedUser) {
    return (
      <div>
        {/* Bouton retour */}
        <button
          onClick={() => setSelectedUser(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 16px',
            background: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            marginBottom: '16px',
            color: '#495057'
          }}
        >
          <span>←</span>
          <span>Retour à la liste</span>
        </button>

        {/* Header utilisateur */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '16px 20px',
          marginBottom: '16px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontWeight: '600',
            fontSize: '18px'
          }}>
            {selectedUser.user_name?.charAt(0)?.toUpperCase() || '?'}
          </div>
          <div>
            <div style={{ fontWeight: '600', fontSize: '16px' }}>{selectedUser.user_name}</div>
            <div style={{ fontSize: '13px', color: '#666' }}>{selectedUser.email}</div>
          </div>
          <span style={{
            marginLeft: 'auto',
            padding: '4px 12px',
            borderRadius: '12px',
            fontSize: '12px',
            background: '#e3f2fd',
            color: '#1976d2'
          }}>
            {selectedUser.role}
          </span>
        </div>

        {/* Timeline de l'utilisateur */}
        <UserActivityTimeline
          userId={selectedUser.user_id}
          token={token}
          startDate={dateRange.start}
          endDate={dateRange.end}
          limit={100}
        />
      </div>
    );
  }

  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f8f9fa' }}>
            <th style={{ padding: '14px', textAlign: 'left' }}>Utilisateur</th>
            <th style={{ padding: '14px', textAlign: 'left' }}>Role</th>
            <th style={{ padding: '14px', textAlign: 'center' }}>Evenements</th>
            <th style={{ padding: '14px', textAlign: 'center' }}>Jours actifs</th>
            <th style={{ padding: '14px', textAlign: 'center' }}>Sessions</th>
            <th style={{ padding: '14px', textAlign: 'left' }}>Derniere activite</th>
            <th style={{ padding: '14px', textAlign: 'center' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
                Aucune donnee d'activite
              </td>
            </tr>
          ) : (
            users.map(user => (
              <tr key={user.user_id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '14px' }}>
                  <div style={{ fontWeight: '500' }}>{user.user_name}</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>{user.email}</div>
                </td>
                <td style={{ padding: '14px' }}>
                  <span style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    background: '#e3f2fd',
                    color: '#1976d2'
                  }}>
                    {user.role}
                  </span>
                </td>
                <td style={{ padding: '14px', textAlign: 'center', fontWeight: '600' }}>
                  {user.total_events}
                </td>
                <td style={{ padding: '14px', textAlign: 'center' }}>
                  {user.active_days}
                </td>
                <td style={{ padding: '14px', textAlign: 'center' }}>
                  {user.sessions}
                </td>
                <td style={{ padding: '14px', fontSize: '13px', color: '#666' }}>
                  {user.last_activity ? new Date(user.last_activity).toLocaleString('fr-FR') : '-'}
                </td>
                <td style={{ padding: '14px', textAlign: 'center' }}>
                  <button
                    onClick={() => setSelectedUser(user)}
                    style={{
                      padding: '6px 12px',
                      background: 'linear-gradient(135deg, #667eea, #764ba2)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500'
                    }}
                  >
                    Voir timeline
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UsersActivityTab;
